import { computed } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import { useStore } from '~/store';
import useAuth from '~/composables/useAuth';

export default function useNotification() {
  const store = useStore();
  const { activeUser } = useAuth();
  const notificationPollInterval = 60000; // 60 seconds
  /**
   * Total number of notifications
   */
  const notificationTotal = computed({
    get() {
      return store.getters['notifications/getNbTotalNotification'];
    },
    set(value) {
      store.commit('notifications/commitTotalNbNotification', value);
    },
  });

  /**
   * Are the notifications opened by default for the user
   */
  const forceNotifications = computed(() => activeUser.value?.notificationMode === 'intrusive' && notificationTotal.value > 0);
  const notificationsKey = computed(() => store.state.notifications.notificationsKey);

  /**
   * todo: document and check usage
   * @param key
   */
  const commitNotificationsKey = (key) => {
    store.commit('notifications/commitNotificationsKey', key);
  };

  /**
   * An apollo smart query to automatically poll the total number of notifications
   */
  const { onResult } = useQuery(
    gql`
        query NotificationTotal {
            myNotifications(first: 100) { paginatorInfo { count }}
        }
    `,
    {},
    {
      pollInterval: notificationPollInterval,
      fetchPolicy: 'network-only',
      enabled: computed(() => !notificationTotal.value), // run if no notification or first loading
    },
  );
  onResult((result) => {
    notificationTotal.value = result.data?.myNotifications?.paginatorInfo?.count ?? 0;
  });

  return {
    notificationPollInterval,
    notificationTotal,
    forceNotifications,
    notificationsKey,
    commitNotificationsKey,
  };
}
